// extracted by mini-css-extract-plugin
export default {"screen":"LoadingScreen_screen__bkHNv","content":"LoadingScreen_content__RLDcx","spinner":"LoadingScreen_spinner__dYsCo","text":"LoadingScreen_text__OKdK2"};